<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
    <Footer v-if="isRouterAlive" />
  </div>
</template>

<script>
import Footer from './common/Footer'
export default {
  name: 'app',
  provide() {
    return {
      reload: this.reload
    }
  },
  components: {
    Footer
  },
  data() {
    return {
      status: 0,
      isRouterAlive: true,
    };
  },
  created() {
    this.getBaseInfo();
  },
  methods: {
    getBaseInfo() {
      this.$httpNew({
        method: 'get',
        url: 'get_base_info'
      }).then(res => {
        document.title = res.site_name;
        this.$store.commit('setBaseInfoValue', res);
        if (!localStorage.getItem('token')) {
          this.$router.push({ path: '/Login' })
        }
      })
      if (localStorage.getItem("token")) {
        this.$httpNew({
          method: 'post',
          url: 'get_user_info',
          data: {},
        }).then(res => {
          if (res.code == 0) {
            this.$store.commit('setUserInfoValue', res.user_info || {});
          }
        })
      }
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
  },
}
</script>

<style>
body .van-toast {
  font-size: 38px;
  padding: 30px;
  line-height: 50px;
  width: 230px;
  background: linear-gradient(30deg, #323233, #000000);
}

body .van-toast .van-toast__icon {
  font-size: 50px;
}

*,
:after,
:before {
  box-sizing: border-box;
}
</style>
